// Tiny env helper — Svelte 5 modules can be imported during SSR too,
// so we guard browser-only globals.
export const browser = typeof window !== "undefined";
